<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印追溯码"
      class="materialCodeModal"
      width="700px"
      top="5vh">
    <!--   36*15-->
    <div id="labelSettings">
      <el-form :inline="true" label-width="80px">
        <el-form-item label="代码">
          <el-input v-model.trim="printCode"/>
        </el-form-item>
        <el-form-item label="日期">
          <el-input v-model.trim="printDate"/>
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model.trim="printQty" @input="codeChange"/>
        </el-form-item>
        <el-form-item label="起始位">
          <el-input v-model.trim="printBegin">
            <el-button type="primary" slot="append" @click="codeChange">重新生成</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-divider/>
    <div id="labelContent7">
      <div v-for="(productInfo,index) in productInfos" :key="index" id="printMaterialBoxLabel7">
        <div style="font-size: 6px;margin-left: 1px;font-family: 'Arial Narrow';font-weight: bold;letter-spacing: -0.5px;">{{productInfo.text1}}</div>
        <div style="font-size: 6px;margin-left: 6px;font-family: 'Arial Narrow';font-weight: bold;letter-spacing: -0.5px;">{{productInfo.text2}}</div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  // import JsBarcode from "jsbarcode";
  import moment from "moment";

  export default {
    data() {
      return {
        dialogVisible: false,
        printCode: "02",
        printQty: 1,
        printDate: "",
        printBegin: "1",
        productInfo: {},
        productInfos: [],
        barCodeText: "",
        printOption: {
          id: "labelContent7",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },

    methods: {
      open(productInfo) {
        this.dialogVisible = true;
        this.productInfo = productInfo;
        this.printDate = moment(new Date(this.productInfo.planStartTime)).format("YYMMDD");
        this.printQty = this.productInfo.quantity;
        this.setBarcode(this.printBegin);
      },

      setBarcode(baseNum) {
        this.productInfos = [];
        for (var i = 0; i < Math.ceil(parseInt(this.printQty) / 2); i++) {
          let index1 = parseInt(baseNum) + 2 * i;
          let index2 = parseInt(baseNum) + 2 * i + 1;
          let text1 = this.printCode + "-" + this.printDate + "-" + this.productInfo.productionOrderNo.substring(this.productInfo.productionOrderNo.length - 4) + "-"
              + index1.toString();
          let text2 = this.printCode + "-" + this.printDate + "-" + this.productInfo.productionOrderNo.substring(this.productInfo.productionOrderNo.length - 4) + "-"
              + index2.toString();
          if (parseInt(baseNum) + parseInt(this.printQty)-1 < parseInt(index2)) {
            text2 = "";
          }
          let info = {
            pkid: i,
            text1: text1,
            text2: text2,
          };
          this.productInfos.push(info);
        }
      },

      codeChange() {
        this.setBarcode(this.printBegin);
      },
    },
  };
</script>

<style lang="scss" scoped>
#printMaterialBoxLabel7 {
  width: 25mm;
  height: 11mm;
  margin: 0 auto;
  //margin-top: 1mm;
  page-break-before: always;
  align-items: center;
  display: flex;
}
</style>
